import { useState } from "react";
import "./SalaryCalculator.css";
import { Link } from "react-router-dom";
import { FaFacebook } from "react-icons/fa";

const SalaryCalculator = () => {
  const [country, setCountry] = useState("DE");
  const [grossSalary, setGrossSalary] = useState("");

  const countryData = {
    DE: {
      name: "Niemcy",
      currency: "€",
      effectiveRate: 0.36,
      benefits: [
        "Kindergeld – ok. 250 € miesięcznie na dziecko",
        "Arbeitslosengeld I – 60–67% ostatniego wynagrodzenia netto",
        "Wohngeld – 150–400 € miesięcznie",
      ],
      source: "Bundesministerium der Finanzen / Arbeitsagentur.de",
    },
    NL: {
      name: "Holandia",
      currency: "€",
      effectiveRate: 0.30,
      benefits: [
        "Zorgtoeslag – do ok. 154 € miesięcznie",
        "Huurtoeslag – 200–400 € miesięcznie",
        "Kinderbijslag – 250–400 € kwartalnie",
      ],
      source: "Belastingdienst.nl",
    },
    FR: {
      name: "Francja",
      currency: "€",
      effectiveRate: 0.32,
      benefits: [
        "CAF – od ok. 130 € miesięcznie",
        "APL – 100–300 € miesięcznie",
        "Prime d'activité – 100–250 € miesięcznie",
      ],
      source: "Service-public.fr",
    },
    NO: {
      name: "Norwegia",
      currency: "NOK",
      effectiveRate: 0.29,
      benefits: [
        "Barnetrygd – ok. 1760 NOK miesięcznie",
        "Dagpenger – ok. 62% dochodu",
        "Kontantstøtte – ok. 7500 NOK miesięcznie",
      ],
      source: "Skatteetaten.no / NAV.no",
    },
    DK: {
      name: "Dania",
      currency: "€",
      effectiveRate: 0.38,
      benefits: [
        "Børne- og ungeydelse – 150–600 € kwartalnie",
        "Boligstøtte – 150–500 € miesięcznie",
        "Dagpenge – do ok. 2 600 € miesięcznie",
      ],
      source: "Skat.dk / Borger.dk",
    },
    ES: {
      name: "Hiszpania",
      currency: "€",
      effectiveRate: 0.28,
      benefits: [
        "Zasiłek dla bezrobotnych – 70% podstawy (6 mies.)",
        "Ingreso Mínimo Vital – 500–1000 € miesięcznie",
        "Wsparcie rodzinne – 100–300 € miesięcznie",
      ],
      source: "Agencia Tributaria / Seguridad Social",
    },
    BE: {
      name: "Belgia",
      currency: "€",
      effectiveRate: 0.40,
      benefits: [
        "Zasiłek rodzinny – 160–180 € miesięcznie",
        "Zasiłek dla bezrobotnych – 60–65%",
        "Minimum socjalne – ok. 1200 €",
      ],
      source: "Belgium.be – Social Security",
    },
    SE: {
      name: "Szwecja",
      currency: "SEK",
      effectiveRate: 0.31,
      benefits: [
        "Barnbidrag – ok. 1250 SEK miesięcznie",
        "Bostadsbidrag – 1000–3000 SEK miesięcznie",
        "A-kassa – do 80% wynagrodzenia",
      ],
      source: "Skatteverket.se / Försäkringskassan",
    },
  };

  const calculateNet = () => {
    const gross = parseFloat(grossSalary);
    if (!gross || gross <= 0) return "-";

    const rate = countryData[country].effectiveRate;
    return Math.round(gross * (1 - rate));
  };

  const calculateBreakdown = () => {
    const gross = parseFloat(grossSalary);
    if (!gross || gross <= 0) return null;

    const rate = countryData[country].effectiveRate;

    return {
      deductions: Math.round(gross * rate),
      ratePercent: Math.round(rate * 100),
    };
  };

  const netSalary = calculateNet();
  const breakdown = calculateBreakdown();

  return (
    <div className="welding-container">
      <h2>
        Kalkulator wynagrodzenia brutto → netto (
        {countryData[country].name})
      </h2>

      <div className="info-box">
        <p>
          ⚠ Wyliczenia mają charakter orientacyjny i bazują na średniej
          efektywnej stopie podatkowej dla wynagrodzeń 2500–4000 brutto.
          Rzeczywiste wynagrodzenie zależy od progów podatkowych,
          ulg i sytuacji rodzinnej.
        </p>
        <p className="info-source">
          Źródło: {countryData[country].source}
        </p>
      </div>

      <div className="form-group">
        <label>Kraj zatrudnienia</label>
        <select value={country} onChange={(e) => setCountry(e.target.value)}>
          {Object.keys(countryData).map((code) => (
            <option key={code} value={code}>
              {countryData[code].name}
            </option>
          ))}
        </select>
      </div>

      <div className="form-group">
        <label>
          Wynagrodzenie brutto (miesięczne) –{" "}
          {countryData[country].currency}
        </label>
        <input
          type="number"
          value={grossSalary}
          onChange={(e) => setGrossSalary(e.target.value)}
          placeholder="Np. 3000"
        />
      </div>

      <div className="result-box">
        <h3>Szacowane wynagrodzenie netto</h3>
        <p>
          <strong>
            {netSalary} {countryData[country].currency}
          </strong>
        </p>
      </div>

      {breakdown && (
        <div className="tax-breakdown">
          <h3>Szacunkowe potrącenia</h3>
          <p>
            Łączne potrącenia: {breakdown.deductions}{" "}
            {countryData[country].currency}
          </p>
          <p>Efektywna stopa: {breakdown.ratePercent}%</p>
        </div>
      )}

      <div className="benefits-box">
        <h3>Możliwe świadczenia socjalne</h3>
        <ul>
          {countryData[country].benefits.map((benefit, index) => (
            <li key={index}>{benefit}</li>
          ))}
        </ul>
      </div>

      <div className="CalculatorLogosMainDiv">
        <Link to="/" className="MainLogoText">
          SteelJobs.pl
        </Link>
        <p>Oferty pracy dla specjalistów branży przemysłowej</p>
        <a className="FooterLink">steeljobs@steeljobs.pl</a>

        <a
          href="https://www.facebook.com/profile.php?id=100083031086146"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaFacebook className="MainPageFBIcon" />
        </a>
      </div>
    </div>
  );
};

export default SalaryCalculator;